/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAutoGeneric48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.57617 14.715C16.9012 11.422 26.0677 9.759 36.2902 9.031L24.2092 8L11.6332 9.29L9.57617 14.715Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.998 28.3795C28.8915 28.3795 30.849 28.125 33.7855 27.2795C35.0355 28.7425 34.8375 30.2095 33.7855 31.6785H23.998V28.3795Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M39.6807 37.9225C41.4907 38.408 43.4112 37.341 45.1482 36.5635L46.5707 32.8375V40.006C46.5707 40.4025 46.4132 40.7825 46.1332 41.0625C45.8532 41.3425 45.4732 41.5 45.0767 41.5C43.9217 41.5 42.3297 41.5 41.1747 41.5C40.3497 41.5 39.6807 40.831 39.6807 40.006V37.9225Z'
        fill='#090A0B'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M41.7869 26.558C43.5191 26.558 44.9234 25.1732 44.9234 23.465C44.9234 21.7568 43.5191 20.372 41.7869 20.372C40.0546 20.372 38.6504 21.7568 38.6504 23.465C38.6504 25.1732 40.0546 26.558 41.7869 26.558Z'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M41.7677 17.7945H41.7672C39.2457 17.7945 37.0497 19.516 36.4477 21.965C36.1127 23.3265 35.8252 24.496 35.8252 24.496'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M43.8683 15.7325C44.7346 15.7325 45.4368 15.0401 45.4368 14.186C45.4368 13.3319 44.7346 12.6395 43.8683 12.6395C43.002 12.6395 42.2998 13.3319 42.2998 14.186C42.2998 15.0401 43.002 15.7325 43.8683 15.7325Z'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M28.1849 36.868H24.5254'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M37.0723 32.2285V26.558'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M6.22812 31.713C6.80553 31.713 7.27362 31.2514 7.27362 30.682C7.27362 30.1126 6.80553 29.651 6.22812 29.651C5.6507 29.651 5.18262 30.1126 5.18262 30.682C5.18262 31.2514 5.6507 31.713 6.22812 31.713Z'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M43.5762 15.9345L43.3457 17.7945'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.002 28.3795C19.1085 28.3795 17.151 28.125 14.2145 27.2795C12.9645 28.7425 13.1625 30.2095 14.2145 31.6785H24.002V28.3795Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.40758 37.9225C6.59758 38.408 4.67708 37.341 2.94008 36.5635L1.51758 33.0385V40.006C1.51758 40.4025 1.67508 40.7825 1.95508 41.0625C2.23508 41.3425 2.61508 41.5 3.01158 41.5H6.91358C7.73858 41.5 8.40758 40.831 8.40758 40.006V37.9225Z'
        fill='#090A0B'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M6.21267 26.558C7.94491 26.558 9.34917 25.1732 9.34917 23.465C9.34917 21.7568 7.94491 20.372 6.21267 20.372C4.48043 20.372 3.07617 21.7568 3.07617 23.465C3.07617 25.1732 4.48043 26.558 6.21267 26.558Z'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M6.23242 17.7945H6.23292C8.75442 17.7945 10.9504 19.516 11.5524 21.965C11.8874 23.3265 12.1749 24.496 12.1749 24.496'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M4.13198 15.7325C4.99824 15.7325 5.70048 15.0401 5.70048 14.186C5.70048 13.3319 4.99824 12.6395 4.13198 12.6395C3.26572 12.6395 2.56348 13.3319 2.56348 14.186C2.56348 15.0401 3.26572 15.7325 4.13198 15.7325Z'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M23.9365 32.2285H31.181C32.1585 32.2285 33.091 31.819 33.7525 31.0995C34.414 30.3795 34.7435 29.416 34.6615 28.442C34.652 28.3315 34.643 28.223 34.6335 28.116C34.5195 26.7615 33.6095 25.605 32.32 25.175C30.5605 24.614 27.7405 23.9805 23.9365 23.9805H24.0645C20.2605 23.9805 17.4405 24.614 15.6825 25.179C14.3945 25.6085 13.4855 26.7635 13.3715 28.1165C13.358 28.223 13.349 28.3315 13.3395 28.442C13.2575 29.416 13.587 30.3795 14.2485 31.0995C14.91 31.819 15.8425 32.2285 16.82 32.2285H24.0645'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M28.1844 19.341C28.1844 19.341 27.2659 18.8255 23.9974 18.8255H24.0024C20.7339 18.8255 19.8154 19.341 19.8154 19.341'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M40.0369 18.043C40.0369 18.043 39.0774 18.1915 37.9949 18.359C36.0089 18.6665 33.9804 18.5435 32.0459 17.9985C31.1964 17.759 30.2924 17.5045 29.5274 17.289C28.2899 16.9405 27.0099 16.7635 25.7244 16.7635C24.8449 16.7635 23.9979 16.7635 23.9979 16.7635H24.0029H22.2764C20.9909 16.7635 19.7109 16.9405 18.4734 17.289C17.7084 17.5045 16.8044 17.759 15.9549 17.9985C14.0204 18.5435 11.9919 18.6665 10.0059 18.359C8.92337 18.1915 7.96387 18.043 7.96387 18.043'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M41.7095 17.7945H42.081C44.7975 17.7945 47 19.997 47 22.7135V30.577C47 32.382 46.283 34.1135 45.0065 35.39C43.73 36.6665 41.9985 37.3835 40.1935 37.3835C38.009 37.3835 35.4805 37.3835 32.8895 37.3835C32.234 37.3835 31.3215 38.93 29.753 38.93H24.0025H23.9975H18.247C16.6785 38.93 15.766 37.3835 15.1105 37.3835H7.8065C6.0015 37.3835 4.27 36.6665 2.9935 35.39C1.717 34.1135 1 32.382 1 30.577C1 27.989 1 25.0935 1 22.7135C1 19.997 3.2025 17.7945 5.919 17.7945H6.2905'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M19.8154 36.868H23.4749'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M10.9277 32.2285V26.558'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M41.7721 31.713C42.3495 31.713 42.8176 31.2514 42.8176 30.682C42.8176 30.1126 42.3495 29.651 41.7721 29.651C41.1946 29.651 40.7266 30.1126 40.7266 30.682C40.7266 31.2514 41.1946 31.713 41.7721 31.713Z'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M39.7377 17.656C39.7377 17.656 37.2502 12.1585 36.3457 10.1595C36.1657 9.7615 35.8512 9.4395 35.4572 9.25C34.3592 8.991 31.3807 8.5155 23.9407 8.5155H24.0597C16.6197 8.5155 13.6412 8.991 12.5487 9.2615C12.1577 9.4495 11.8452 9.7695 11.6662 10.165C10.7502 12.1585 8.2627 17.656 8.2627 17.656'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
      <path
        d='M4.42383 15.9345L4.65433 17.7945'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M36.3134 18.0155C35.6274 15.3355 33.4924 13.8245 30.6294 14.176C29.0039 14.3755 27.6239 15.1215 26.7844 16.126L26.0889 17.046'
        stroke='#090A0B'
        strokeWidth={1.5}
        strokeMiterlimit={1.5}
      />
    </svg>
  );
}

export default SvgAutoGeneric48;
